import React, { useState, useEffect } from "react";

import { IServiceCategory } from "app/api/types";
import "./styles.scss";
import { Link } from "react-router-dom";

interface IProps {
  serviceCategory: IServiceCategory;
  isActive: boolean;
  onSubmit: (data: IServiceCategory) => void;
}

const EditServiceCategoryForm: React.FC<IProps> = props => {
  const [title, setTitle] = useState(props.serviceCategory.title);
  const [errorStyle, setErrorStyle] = useState({
    title: ""
  });

  const handleChange = (e: any) => {
    e.target.name === "title" && setTitle(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (title.length > 1)
      props.onSubmit({
        id: props.serviceCategory.id,
        title,
        href: props.serviceCategory.href
      });
  };

  useEffect(() => {
    setErrorStyle({
      title: title && title.length > 1 ? "" : "edit-phrase__input_error"
    });
  }, [title]);

  return (
    <form
      className={`edit-phrase__form ${props.isActive ? "active" : ""}`}
      onSubmit={handleSubmit}
    >
      <label htmlFor="phrase" className="edit-phrase__label">
        название услуги
      </label>
      <input
        className={`edit-phrase__input ${errorStyle.title}`}
        type="text"
        placeholder={title}
        name="title"
        value={title}
        onChange={handleChange}
        autoComplete="off"
      />

      <button className="edit-phrase__submit">cохранить</button>

      <Link
        to={`pages/${props.serviceCategory.href}`}
        key={props.serviceCategory.id}
      >
        Редактировать страницу
      </Link>
    </form>
  );
};

export default EditServiceCategoryForm;
